import { Controller } from "react-hook-form";
import { Box, FormHelperText, FormLabel } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import { useFieldsStyles } from "../fields.styles";
import { DateFieldProps } from "./date-field.props";

export const DateField = (props: DateFieldProps) => {
  const classes = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);

  const format = () => {
    if (props.format) {
      return props.format;
    }

    if (!!props.withTime) {
      return "YYYY-MM-DD hh:mm A";
    }

    return "YYYY-MM-DD";
  };
  const placeholder = props.placeholder ?? format();

  const Picker = !!props.withTime ? KeyboardDateTimePicker : KeyboardDatePicker;

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={classes.fieldWrapper}>
          <Box display="flex" justifyContent="space-between">
            <FormLabel htmlFor={props.name} error={hasError} required={props.required}>
              {props.label}
            </FormLabel>
          </Box>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Picker
              {...{ ...renderProps.field, ref: undefined }}
              innerRef={renderProps.field.ref}
              ampm={!!props.withTime}
              autoOk={true}
              disabled={Boolean(props.disabled) || !canEdit}
              disableToolbar={!props.withTime}
              id={props.name}
              error={hasError}
              format={format()}
              fullWidth
              placeholder={placeholder}
              variant="inline"
              KeyboardButtonProps={{ title: "Open Picker" }}
            />
          </MuiPickersUtilsProvider>
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
